// extracted by mini-css-extract-plugin
export default {"container":"MoneyBackGuarantee_container__Ggcpz","text":"MoneyBackGuarantee_text__1cZUW"};